module.exports = __webpack_public_path__ + "static/media/Icons-28.3c77c1e2.png";